
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/amazon-leadership-principles",
      function () {
        return require("private-next-pages/amazon-leadership-principles.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/amazon-leadership-principles"])
      });
    }
  